export const STATES = {
  NEED_EMAIL_VALIDATION: "NEED_EMAIL_VALIDATION",
  NEED_INFOS: "NEED_INFOS",
  VALIDATED: "VALIDATED",
};

export const ROLES = {
  EIG_ECRITURE: "Eig_Ecriture",
  EIG_LECTURE: "Eig_Lecture",
};
